module.exports = __webpack_public_path__ + "img/FK.039a6f96.png";